export function topjustimginit() {
    if (location.pathname == "/") {

        let justimgs = document.querySelectorAll(".justimg");

        let range
        let size = []
        let maxRange

        window.addEventListener("resize", () => {
            resizeEvent()
        })
        resizeEvent()

        if (window.innerWidth > 1024) {
            justimgs.forEach((justimg) => {
                window.addEventListener("scroll", () => {
                    let figure = justimg.querySelector("figure")

                    if (window.innerWidth > 1024) {
                        range = window.scrollY + window.innerHeight / 2
                        maxRange = justimg.offsetTop + (window.innerWidth * 0.5622254758 / 2)
                    } else {
                        range = window.scrollY + window.innerHeight * 0.66
                        maxRange = justimg.offsetTop + window.innerWidth
                    }

                    if (justimg.offsetTop < range && range <= maxRange) {
                        let percent = (range - justimg.offsetTop) / (maxRange - justimg.offsetTop)

                        figure.style.width = ((window.innerWidth - size[0]) * percent + size[0]) + "px"
                        figure.style.height = ((window.innerHeight - size[1]) * percent + size[1]) + "px"
                        figure.style.borderRadius = (size[2] * (1 - percent)) + "px"

                    } else if (range <= justimg.offsetTop) {
                        figure.style.width = size[0] + "px"
                        figure.style.height = size[1] + "px"
                        figure.style.borderRadius = size[2] + "px"

                    } else if (maxRange < range) {
                        figure.style.width = window.innerWidth + "px"
                        figure.style.height = window.innerHeight + "px"
                        figure.style.borderRadius = "0px"
                    }
                })
            })
        } else {
            justimgs.forEach((justimg) => {
                let figure = justimg.querySelector("figure")

                figure.style.width = window.innerWidth + "px"
                figure.style.height = window.innerHeight + "px"
                figure.style.borderRadius = "0px"
            })
        }

        function resizeEvent() {
            if (window.innerWidth > 1024) {
                size[0] = window.innerWidth * 0.92679355783308931185944363103953147877
                size[1] = window.innerWidth * 0.48901903367496339677891654465592972181
                size[2] = window.innerWidth * 0.0439238653001464128843338213762811127

            } else {
                size[0] = window.innerWidth * 0.84615384615384615384615384615384615384
                size[1] = size[0]
                size[2] = window.innerWidth * 0.115384615384615384615384615384615384615

            }
        }
    }
}